// Local translations
export const T = {
  en_GB: {
    editWithdrawal: "Edit Withdrawal",
    addWithdrawal: "Add Withdrawal",
    editDescription: "Update the planned withdrawal details.",
    addDescription: "Add a planned withdrawal from your investment portfolio.",
    nameRequired: "Name is required",
    amountPositive: "Amount must be greater than 0",
    monthRequired: "Month is required for one-time withdrawals",
    startMonthRequired: "Start month is required for recurring withdrawals",
    endBeforeStart: "End month must not be before start month",
    failedToSave: "Failed to save withdrawal",
    purpose: "Purpose",
    purposePlaceholder: "e.g., Buy a house, Extra pension",
    type: "Type",
    selectType: "Select type",
    oneTime: "One-time",
    recurring: "Recurring",
    amount: "Amount",
    month: "Month",
    selectMonth: "Select month",
    frequency: "Frequency",
    selectFrequency: "Select frequency",
    monthly: "Monthly",
    quarterly: "Quarterly",
    yearly: "Yearly",
    startMonth: "Start Month",
    selectStartMonth: "Select start month",
    endMonthOptional: "End Month (optional)",
    selectEndMonth: "Select end month",
    endMonthNote: (years: number) =>
      `If not set, withdrawals will continue until end of forecast period (${years} years)`,
    cancel: "Cancel",
    save: "Save",
  },
  nb_NO: {
    editWithdrawal: "Rediger uttak",
    addWithdrawal: "Legg til uttak",
    editDescription: "Oppdater detaljer for planlagt uttak.",
    addDescription: "Legg til et planlagt uttak fra investeringsporteføljen din.",
    nameRequired: "Navn er påkrevd",
    amountPositive: "Beløp må være større enn 0",
    monthRequired: "Måned er påkrevd for engangsuttak",
    startMonthRequired: "Startmåned er påkrevd for gjentakende uttak",
    endBeforeStart: "Sluttmåned kan ikke være før startmåned",
    failedToSave: "Kunne ikke lagre uttak",
    purpose: "Formål",
    purposePlaceholder: "f.eks. Kjøpe hus, Ekstra pensjon",
    type: "Type",
    selectType: "Velg type",
    oneTime: "Engangs",
    recurring: "Gjentakende",
    amount: "Beløp",
    month: "Måned",
    selectMonth: "Velg måned",
    frequency: "Frekvens",
    selectFrequency: "Velg frekvens",
    monthly: "Månedlig",
    quarterly: "Kvartalsvis",
    yearly: "Årlig",
    startMonth: "Startmåned",
    selectStartMonth: "Velg startmåned",
    endMonthOptional: "Sluttmåned (valgfritt)",
    selectEndMonth: "Velg sluttmåned",
    endMonthNote: (years: number) =>
      `Hvis ikke angitt, fortsetter uttakene til slutten av prognoseperioden (${years} år)`,
    cancel: "Avbryt",
    save: "Lagre",
  },
} as const;
